import React from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import { Theme } from '@seedlang/constants';
import { AppUI, ExerciseUI } from '@seedlang/state';

export const LabelWrapper = styled.div`
  z-index: ${Theme.z['over-foreground']};
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${props => props.marginTop};
`;

export const Label = styled.div`
  background: ${props => props.background};
  color: white;
  padding: 3px 7px;
  font-size: 11px;
  line-height: 12px;
  font-weight: 700;
  width: ${props => props.width};
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

@observer
class WorksheetLabel extends React.Component {
  shouldShowFreeLabel() {
    const worksheet = this.props.worksheet;
    return worksheet?.published && worksheet?.accessWithoutMembership && (!ExerciseUI.user.isMember || AppUI.isPaymentMigrationStartable);
  }

  getLabelText() {
    const type = this.props.type || (this.props.worksheet ? 'free' : null);
    const typeToText = {
      free: 'FREE',
      new: 'NEW',
    };
    return typeToText[type] || 'FREE';
  }

  render() {
    const type = this.props.type || (this.props.worksheet ? 'free' : null);
    const show = this.props.show !== undefined ? this.props.show : (type === 'free' ? this.shouldShowFreeLabel() : true);
    
    if (!show) {
      return null;
    }

    const background = this.props.background || AppUI.site.secondaryAccentColor || AppUI.site.accentColor;
    const text = this.getLabelText();
    const width = this.props.width || '40px';

    return (
      <LabelWrapper
        marginTop={this.props.marginTop}
      >
        <Label
          background={background}
          width={width}
        >
          {text}
        </Label>
      </LabelWrapper>
    );
  }
}

export default WorksheetLabel;

